<template>
    <section class="contain">
        <div class="inner" :style="{ minHeight: screenHeight }">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <h1 class="panel-title">Concierge Services</h1>
                </div>
                <div class="panel-body">
                    <p>
                        To reach the Hotel Concierge, please email them at
                        <a
                            class="my-link"
                            href="mailto:london.concierge@rosewoodhotels.com"
                        >
                            london.concierge@rosewoodhotels.com</a
                        >
                        Or call
                        <b>+44 20 7781 8888</b>
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data: () => ({
        screenHeight: window.innerHeight + "px",
    }),
};
</script>
